import React from 'react';
import { ListBase, ListProps } from 'react-admin';
import { NetOrcaTableListV1 } from '../Common/NetOrcaTableList';
import { useLinkedPin } from '../Common/DataList';
import ApplicationCard from './ApplicationCard';
import './Applications.css';

/**
 * A grid and nothing else: no filters and no row view, so the standard list is
 * used only for what a grid still needs — pages arriving on scroll, the empty
 * state and the count underneath. Tiles go through `renderRow` rather than
 * `renderCard` because offering a card view is what puts the view switch on the
 * page, and there is no second view to switch to. The header ribbon it would
 * otherwise leave behind is closed in the stylesheet.
 */
const ApplicationsListView = () => (
    <NetOrcaTableListV1
        className="netorca-app"
        dataCy="application-result-list"
        fields={[]}
        columns={[]}
        emptyText="Applications appear here once a declaration has been sent"
        noun="application"
        // one open at a time, named in the URL hash, so an opened application
        // survives a reload and can be linked to — by name, as the search bar
        // and everything written before it do
        accordion={{ aliasOf: (record) => record.name }}
        renderRow={(record, row) => (
            <ApplicationCard
                key={record.id}
                record={record}
                open={row.open}
                toggle={row.toggle}
                scrollIntoView={row.scrollIntoView}
            />
        )}
    />
);

/**
 * The applications this team has declared, as a grid of tiles. Each one says
 * how much of it is running and what is still outstanding; the counts behind
 * both come down with the list itself, so a page of tiles is one request.
 */
const ApplicationList = (props: ListProps) => {
    // a link to an application puts it first, wherever it would be
    const pin = useLinkedPin();
    return (
        // the light serializer carries the state, the metadata and every count
        // the tiles draw
        // a new link is a new list — see useLinkedPin
        <ListBase key={pin.pin ?? ''} filter={{ light: true, ...pin }} perPage={25} {...props}>
            <ApplicationsListView />
        </ListBase>
    );
};

export default ApplicationList;
